import React, { useEffect } from "react";
import { FaAngleLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AlertBox from "../../../components/common/AlertBox";
import Loading from "../../../components/common/Loading";
import LogoContainer from "../../../components/home/header/LogoContainer";
import LeftSection from "../../../components/login/LeftSection";
import VerifyUserForm from "../../../components/login/VerifyUserForm";
import {
  getAccessToken,
  getVerifyUserError,
  getVerifyUserStatus,
  removeVerifyUserMessage,
} from "../../../redux/slice/userSlice";

const VerifyUser = () => {
  const navigate = useNavigate();
  const token = useSelector(getAccessToken);

  const status = useSelector(getVerifyUserStatus);
  const error = useSelector(getVerifyUserError);

  useEffect(() => {
    if (token) {
      navigate("/client/home", { replace: true });
    }
  }, [navigate, token]);

  return (
    <div className="flex justify-center items-start">
      {/* Notification */}
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? (
        <AlertBox
          type={status}
          message={error}
          toDispatch={removeVerifyUserMessage}
        />
      ) : null}
      {status === "success" ? (
        <AlertBox
          type="success"
          message="Verified Successfully"
          toDispatch={removeVerifyUserMessage}
        />
      ) : null}
      <LeftSection />

      {/* Right Section */}
      <section className="flex-1 items-center flex flex-col md:py-8 py-5">
        <div className="flex justify-between sm:px-12 px-0 w-full">
          <div className="w-full flex justify-between items-center">
            <Link
              className="flex justify-center items-center max-w-[100px]"
              to="/login"
            >
              <FaAngleLeft className="text-textPrimary" />
              <span className="text-textPrimary font-semibold pl-1">Back</span>
            </Link>
            <LogoContainer />
          </div>
        </div>
        <div className="py-6">
          <div className="flex flex-col sm:w-[425px] w-[270px] gap-[10px]">
            <div className="flex flex-col">
              <h1 className="text-textPrimary font-bold font-poppins sm:text-[30px] text-[26px] leading-[45px]">
                Verify Account
              </h1>
              <p className="text-textSecondary">
                Please click the button to verify your account!
              </p>
            </div>
            <VerifyUserForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default VerifyUser;
